import { Injectable, RendererFactory2 } from '@angular/core';
import { UploadStateService } from './upload-state.service';
import { HttpRequestCounterInterceptor } from './interceptor/http-request-counter.interceptor';

@Injectable({ providedIn: 'root' })
export class VersionCheckService {
  private currentHash: string | null = null;
  private lastActivityTime = this.now();
  private readonly idleThresholdMs = 60 * 1000;
  private readonly pollIntervalMs = 5 * 60 * 1000;
  private pollTimer: any = null;

 
  private readonly blockedRoutePatterns: string[] = [
    '/material/inbound-form',
    '/material/outbound-form',
    '/material/scrap-form',
  ];

  constructor(
    private readonly rendererFactory: RendererFactory2,
    private readonly uploadStateService: UploadStateService,
    private readonly httpCounter: HttpRequestCounterInterceptor
  ) {}

  startPolling(): void {
    this.trackUserActivity();
    this.pollVersion();
    if (this.pollTimer === null) {
      this.pollTimer = setInterval(() => this.pollVersion(), this.pollIntervalMs);
    }
  }

  private trackUserActivity(): void {
    const renderer = this.rendererFactory.createRenderer(null, null);
    ['mousemove', 'keydown', 'click', 'touchstart'].forEach(event => {
      renderer.listen('document', event, () => {
        this.lastActivityTime = this.now();
      });
    });
  }

  private async pollVersion(): Promise<void> {
    try {
      const response = await fetch(`/version.json?t=${this.now()}`, { cache: 'no-store' });
      if (!response.ok) {
        return;
      }
      const data = await response.json();
      if (!data?.hash) {
        return;
      }
      if (!this.currentHash) {
        this.currentHash = data.hash;
        return;
      }
      if (data.hash !== this.currentHash && this.isIdle()) {
        this.reload();
      }
    } catch {
      // network error — ignore and retry on next interval
    }
  }

  private isIdle(): boolean {
    if (this.isOnBlockedRoute()) {
      return false;
    }
    const msSinceActivity = this.now() - this.lastActivityTime;
    return (
      !this.uploadStateService.isUploading() &&
      !this.uploadStateService.isScanning() &&
      !this.httpCounter.hasPendingRequests() &&
      msSinceActivity >= this.idleThresholdMs
    );
  }

  private isOnBlockedRoute(): boolean {
    const url = this.getCurrentUrl();
    return this.blockedRoutePatterns.some(pattern => url.includes(pattern));
  }

  protected getCurrentUrl(): string {
    return typeof globalThis !== 'undefined' && globalThis.location
      ? globalThis.location.pathname + globalThis.location.search
      : '';
  }

  protected now(): number {
    return Date.now();
  }

  protected reload(): void {
    globalThis.location.reload();
  }
}
